import { Tools } from "@comunicare/comunicare-helper";
import { AbstractRiskAssessment, IRiskAssessment } from "@comunicare/comunicare-interfaces";
import { TranslateService } from "@ngx-translate/core";

export class RiskAssessment extends AbstractRiskAssessment implements IRiskAssessment {
  private translateService: TranslateService;
  constructor(data: IRiskAssessment, translateService: TranslateService) {
    super(data);
    this.translateService = translateService;
  }
  protected uniqObject(obj: Record<string, unknown>[]): { rationale: string; version: string }[] {
    return Tools.uniqObject(obj);
  }
  protected translate(key: string): string {
    return this.translateService.instant(key);
  }
}
